<template>
    <section class="site-container" :class="{ 'is-loaded': isPageLoaded }">
        <component
            v-bind="blockContent"
            :is="getBlockComponent(blockTitle)"
            :shopwareId="shopwareId"
            :categoryId="shopwareId"
            :componentId="componentId"
            :typePage="type"
            :pageTitle="pageTitle"
            :blog="blog"
            @image-loaded="onImageLoaded" />
    </section>
</template>

<script setup lang="ts">
    defineProps({
        blockTitle: String,
        shopwareId: String,
        componentId: String,
        type: String,
        blockContent: Object,
        pageTitle: String,
        blog: Boolean,
    });

    const blockComponents = import.meta.glob('../block/**/*.vue', {
        eager: true,
    }) as Record<string, { default: any }>;

    function getBlockComponent(name: string) {
        const components: Record<string, any> = Object.keys(blockComponents).reduce(
            (acc: Record<string, any>, path: string) => {
                const componentName = path.split('/').pop()?.replace('.vue', '') || '';
                // Handle index.vue files (use parent folder name)
                if (componentName === 'index') {
                    const folderName = path.split('/').slice(-2, -1)[0];
                    acc[folderName.toLowerCase()] = (blockComponents[path] as any).default;
                } else if (componentName) {
                    acc[componentName.toLowerCase()] = (blockComponents[path] as any).default;
                }
                return acc;
            },
            {},
        );

        return components[name.toLowerCase()] || null;
    }

    // extras

    const isPageLoaded = ref(false);

    const onImageLoaded = () => {
        isPageLoaded.value = true;
    };
</script>
